import React from "react"

export default function ExperienceView(props) {
    return (
      <div class="experience-container">
        <p> ● {props.experience}</p>
      </div>
    )
  }